import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-flexbox-grid';
import { Field } from 'redux-form';
import _get from 'lodash/get';

import { entityType } from 'types';

import FormGroupAutoCompleteField from 'components/AutoCompleteMenuWrapper';

import '../../../../style.scss';

const EntitySpan = ({ formFieldsPath, matchingPatterns, fromFieldPayload }) => {
  const matchingPatternsTo = useMemo(() => {
    const fromIndex = _get(fromFieldPayload, 'index', 0);

    return matchingPatterns.slice(fromIndex);
  }, [fromFieldPayload, matchingPatterns]);

  const fromOrder = _get(fromFieldPayload, 'order', 0);

  return (
    <React.Fragment>
      <div styleName="span-container">
        <span styleName="span-label">SPANS</span>
        <i className="icon-arrow-right" />
      </div>
      <div styleName="from-label">From:</div>
      <Col xs={2} styleName="dropdown">
        <Field
          name={`${formFieldsPath}.matching_pattern_element_from`}
          itemWithIndex
          component={FormGroupAutoCompleteField}
          items={matchingPatterns}
          placeholder="Select Entity"
        />
      </Col>

      <div styleName="to-label">To:</div>
      <Col xs={2} styleName="dropdown">
        <Field
          name={`${formFieldsPath}.matching_pattern_element_to`}
          itemWithIndex
          itemIndexOffset={fromOrder}
          component={FormGroupAutoCompleteField}
          items={matchingPatternsTo}
          placeholder="Select Entity"
        />
      </Col>
    </React.Fragment>
  );
};

EntitySpan.propTypes = {
  formFieldsPath: PropTypes.string.isRequired,
  matchingPatterns: PropTypes.arrayOf(entityType).isRequired,
  /* eslint-disable react/forbid-prop-types */
  // We can not use shape here because shape is required by default and we get a warning
  fromFieldPayload: PropTypes.object,
  /* eslint-enable react/forbid-prop-types */
};

export default EntitySpan;
